/* eslint react/no-multi-comp: 0 */
import React from 'react';

import { Button, EmptyState } from '@ui/components';

export const NoRecordsEmptyStateExample = () => (
    <EmptyState
        title="No campaigns yet"
        message="Campaigns you create will appear here."
    />
);

export const NoSearchResultsEmptyStateExample = () => (
    <EmptyState
        title="No results"
        message="No campaigns match your current filters."
    />
);

export const NoConfiguredItemsEmptyStateExample = () => (
    <EmptyState
        title="No placements configured"
        message="Configured placements will appear here once set up."
    />
);

export const ActionSlotEmptyStateExample = () => (
    <EmptyState
        title="No campaigns yet"
        message="Create your first campaign to get started."
        action={<Button variant="primary">Create campaign</Button>}
    />
);

export const MessageOnlyEmptyStateExample = () => (
    <EmptyState message="No records found." />
);
